// 수행평가
import Resource from '../Resource'

export default class PortfolioTest extends Resource {
  static ENDPOINT = '/api/test/portfolio/test'

  constructor (args) {
    super()
    this.extend(args)
  }

  static create (subject) {
    subject.evals = []
    return new PortfolioTest(subject)
  }
}
